module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter-h"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("8")])])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "chaphead-image2"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("“I Feel So Trapped”")])])]), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("W")]), _vm._v("hen the FBI put Ray on the most-wanted list on April 19 and broadcast his picture internationally on television on the twenty-first, most people assumed the hunt would soon be over. But days and then weeks passed, and public frustration and speculation mounted. The FBI was accused of incompetence or even abetting the fugitive’s escape. A common notion was that Ray had probably been killed by coconspirators."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-1",
      "id": "ch08-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" Author Truman Capote reflected that conclusion when he confidently announced on "), _c('i', [_vm._v("The Tonight Show")]), _vm._v(", “James Earl Ray is dead. He has been dead for at least a month.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-2",
      "id": "ch08-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" More than a dozen corpses—bodies that matched Ray in age and height—found in the United States and Mexico had their fingerprints and teeth compared to Ray’s records."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-3",
      "id": "ch08-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Each time, the police had to wait for pathology reports before knowing whether the hunt was still on. All the while, hundreds of leads on a living Ray continued to pour into the FBI: He had boarded a yacht in Key West and was now living in Cuba; he had been flown by the CIA to South America; he had driven his Mustang up a ramp into the rear of a large moving truck and was now sheltered by a secret KKK underground gang."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-4",
      "id": "ch08-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rumors of a conspiracy grew daily. The nation’s black community was convinced of it, fueled by statements from Ralph Abernathy, who also spoke on behalf of Coretta King, Jesse Jackson, and other civil rights leaders."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-5",
      "id": "ch08-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" By mid-April, just weeks after the murder, the Kennedy Assassination Inquiry Committee, "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("a group of hardcore JFK conspiracy buffs, announced that the King suspect looked like one of three unidentified tramps photographed at Dealey Plaza after the JFK assassination."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-6",
      "id": "ch08-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" Louis Lomax, a prominent black journalist, began working on a syndicated series that would place Ray doing the hit for a wealthy New Orleans industrialist, and the FBI protecting him after the murder. White hate groups promoted the idea that King had been killed as a result of internecine rivalries within the SCLC, or at the very least by black militants who resented his popularity and nonviolent message.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The FBI, with the help of Canadian and Mexican authorities, searched for Ray both north and south of the border. Ray had visited both Mexico and Canada in 1967, so the Bureau knew either was likely. The Royal Canadian Mounted Police, under Superintendent Charles Sweeney, established a task force of a dozen officers in early May. At the External Affairs Passport Division Office in the capital, Ottawa, they slowly worked through 264,000 passport applications made since Ray had escaped from Missouri State Penitentiary back on April 23, 1967."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-7",
      "id": "ch08-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On May 20, a twenty-eight-year-old Canadian policeman suddenly stopped and stared at a photo. There was the same thin nose, the slightly protruding left ear, the dark hair, the sallow complexion. But the man in the passport application, a Ramon George Sneyd, sported thick, black horn-rimmed glasses. None of the photos circulated of Ray showed him wearing glasses. “This looks like him if he wore glasses,” the policeman announced."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-8",
      "id": "ch08-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" The rest of the officers examined the photo, but most did not think it looked like Ray. Nevertheless, it was put aside along with eleven other “possibles.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As breaks in cases go, the Sneyd passport application was a lucky one. There was a real Ramon Sneyd, and he was a police officer in Toronto."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn08-08-1",
      "id": "fn08-1"
    }
  }, [_vm._v("*")]), _vm._v(" One call to the real Sneyd revealed that he had never applied for a passport, although somebody claiming to be from the Passport Division had called him around May 1 asking if he had lost a passport. “You’ve got the wrong Mr. Sneyd,” he told the stranger. The Mounties sent a copy of the passport application to Washington, where FBI handwriting experts confirmed that the "), _c('i', [_vm._v("S")]), _vm._v(" and "), _c('i', [_vm._v("G")]), _vm._v(" of the signed Ramon George Sneyd matched the capital "), _c('i', [_vm._v("S")]), _vm._v(" and "), _c('i', [_vm._v("G")]), _vm._v(" of Eric S. Galt."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-9",
      "id": "ch08-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That prompted an alert to Canadian customs and immigration authorities. The Toronto address Ray had given on the Sneyd passport application was a "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("rooming house at 962 Dundas Street, run by Mrs. Sun Fung Loo. Soon they discovered that Ray, using the alias Paul Bridgman, had arrived in Toronto no later than April 8, only four days after King’s murder, and had stayed at a rooming house on Ossington Avenue. The real Paul Bridgman was a thirty-five-year-old consultant at the Toronto Board of Education.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("The Mounties then traced Ray’s path to a travel agency—the Kennedy Travel Bureau—and learned that there, using his Sneyd alias, he had bought an excursion-fare ticket to London and had left on May 6. While the Toronto-London portion of the ticket had been used, the return to Toronto had not. Ray could still be in Europe. Since the FBI had located letters from Ray inquiring about immigrating to white-run Rhodesia, it was also possible he might be there, and getting extradition for the murderer of Martin Luther King from a country that practiced aggressive race politics would not be easy."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-10",
      "id": "ch08-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("June 8, 1968, was a surprisingly warm day for London and the last vestiges of fog had burned off by midmorning. The conversation that dominated the city—whether among picture-snapping tourists strolling by Buckingham Palace or bare-chested soccer players in Regents Park—was the assassination of Senator Robert Kennedy only two days earlier in Los Angeles. Much of the London commentary centered on how America’s predisposition for violence had unalterably changed its political and social climate. Just two months earlier a single bullet had shattered Martin Luther King’s face while he leaned over a balcony railing at a Memphis motel. In the Kennedy murder, the assassin—a twenty-four-year-old Palestinian named Sirhan Sirhan—was grabbed at the scene. It highlighted even more the failure of the FBI to find James Earl Ray.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Around 11:30 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v("., at Heathrow Airport’s Terminal Two, an unassuming middle-aged man strolled through the frenetic crowds to the passport desk."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-11",
      "id": "ch08-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" The traveler wore a knee-length beige raincoat over a dark sports jacket and gray trousers. He calmly pulled a blue Canadian passport—in the name of Ramon George Sneyd—from a billfold in his jacket pocket and handed it to a young immigration officer. His destination was Brussels.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Everything seemed in order. The passport had been issued just three weeks earlier at the Canadian Embassy in Lisbon, Portugal."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-12",
      "id": "ch08-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" The photo—of a neatly dressed, bespectacled man—matched the traveler.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“May I see the other one?” the immigration officer suddenly asked. When Ray had closed his billfold, the officer had noticed a second passport."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-13",
      "id": "ch08-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Ray seemed unfazed. The second passport was a canceled one, identical to the first except it had been issued in Ottawa in late April under the name Ramon George Sneya."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-14",
      "id": "ch08-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why are the names different?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("Ray said that he had misspelled his own name in Canada, but had not had time to fix it before leaving on his trip. In Lisbon, he visited the Canadian Embassy, where he had his old passport canceled and was issued a new one. While he spoke, a second policeman at the passport desk, Detective Sergeant Philip Birch, stared at him intently. “My first impression of him was that he was an academic,” recalls Birch, “almost an absent-minded professorial air about him, and that he was slightly nervous. I did not attach any significance to that, since so many passengers are nervous about flying.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-15",
      "id": "ch08-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Part of Birch’s duties included checking all the passengers against the “Watch For and Detain” booklet. He immediately saw an “All Ports Warning”—issued only two days earlier—that Ramon George Sneyd was wanted by Scotland Yard for “serious offences.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-16",
      "id": "ch08-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" He now took both passports.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I say, old fellow, would you mind stepping over here for a moment? I’d like to have a word with you.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-17",
      "id": "ch08-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" When Ray protested that he had a flight to catch, Birch assured him he would not miss it. With another policeman in tow, they walked the long distance across the sprawling terminal to an administrative office."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-18",
      "id": "ch08-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once inside, Birch asked, “Would you mind if I searched you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ray stood and raised his arms from his sides. Birch quickly found a Japanesemade. 38 revolver in Ray’s right trouser pocket."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-19",
      "id": "ch08-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" The handle was wrapped with black electrician’s tape, the kind professional gunmen use to reduce the slipperiness of smooth-handled revolvers or to strap a gun to a lower leg in the hope of avoiding detection if searched. Birch opened the barrel and spun it. It had five bullets. The safety catch was on."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-20",
      "id": "ch08-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why are you carrying this gun?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ray’s eyes darted down and away. “Well, I am going to Africa. I thought I might need it.” A crooked smile crossed his face. “You know how things are there.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-21",
      "id": "ch08-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Birch assumed he was lying. If he was worried about conditions in Africa, there was no reason to travel with a loaded pistol in London. “I have reason to believe you have committed an arrestable offense,” Birch said softly while handing the pistol to another policeman. Ray seemed unconcerned. Birch continued the search. Among other items, he found a one-way ticket to Brussels, the unused return portion of a ticket between London and Toronto, and a certified birth certificate in the name of Ramon George Sneyd."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-22",
      "id": "ch08-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Soon, two of Scotland Yard’s top investigators—Detective Chief Superintendent Thomas Butler, who had cracked the Great Train Robbery of 1963, and Chief Inspector Kenneth Thompson of the Interpol office—arrived."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-23",
      "id": "ch08-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We are police officers,” said Butler in a formal, clipped tone. “I understand you have in your possession two passports in the names Sneya and Sneyd. What is your name?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("“I can’t understand why I am here,” Ray protested. His voice rose slightly, a tone of nervousness having broken his calm detachment. “My name is Sneyd.”")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Butler held up the passports. “Both passports show that you are a Canadian citizen born in Toronto on October 8, 1932. Are these details correct?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ray seemed impatient. “Yes, of course they are.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This .38 revolver with five rounds of ammunition in its chambers was found in your hip pocket when you were first seen. Is it your gun?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, it is mine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Would you like to tell us why you are carrying a gun at all?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am going to Brussels.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why should you want to take a gun to Brussels?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Again, Ray’s eyes darted to the floor. His words were now a bit rushed. “Well, I am really thinking of going on to Rhodesia and things aren’t too good there right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Butler stared at him for a moment before proceeding. “You have to have a firearms certificate to possess a gun and even ammunition in this country. Have you a firearms certificate issued by the competent authority?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ray shook his head. “No. No, I haven’t any certificate for it.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("Now Butler raised his voice ever so slightly. “I must inform you, Mr. Sneyd, that you are under arrest for possession of a gun without a permit. I must also caution you that anything you say may be held against you.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-24",
      "id": "ch08-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The other police surrounded Ray and spirited him from Heathrow to London’s Cannon Row jail, a five-story redbrick-and-granite cell block located at Scotland Yard. There he was fingerprinted and placed in a large empty cell, with an armed guard posted nearby."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-25",
      "id": "ch08-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" If Ray was nervous, he gave no indication of it. Shortly before 5:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P")]), _vm._v("."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v("., Butler and Thompson entered his cell. Again, Butler did the talking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As a result of inquiries made since you were detained, we have very good reason to believe that you are not a Canadian citizen, but an American.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ray was quiet for a moment, and then nodded his head while muttering, “Oh well, yes, I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Butler ignored him and continued. “I now believe your name is not Sneyd but James Earl Ray, also known as Eric Starvo Galt and other names, and that you are wanted at present in the United States for serious criminal offenses, including murder in which a firearm was used.” His words, enunciated clearly and loudly, reverberated in the small concrete cell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly Ray seemed scared. His body stiffened and his face drained of what little color it had. He staggered backward and then crumpled onto a nearby bench, burying his head in his hands. “Oh God,” he stammered. Then after a moment of silence he spoke again, seemingly more to himself than to anyone else in the cell. “I feel so trapped.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("“I should caution you again,” Butler interrupted, “anything you say may be held against you.”")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Ray did not lift his head. He stared straight at the floor.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("“Yes,” he said weakly. “I shouldn’t say anything more now. I can’t think right.”")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn08-08-2",
      "id": "fn08-2"
    }
  }, [_vm._v("*")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch08-08-26",
      "id": "ch08-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sixty-five-day hunt for the man charged as Martin Luther King’s assassin had ended.")]), _vm._v(" "), _c('p', {
    staticClass: "image-left1"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn08-1",
      "id": "fn08-08-1"
    }
  }, [_vm._v("*")]), _vm._v(" Not only was Sneyd a real person, but living within a few miles of him in the same Toronto neighborhood was an Eric S. Galt, a businessman; John Willard was an insurance appraiser who lived in the same area; a man bearing another name that would soon come into the case, Paul Bridgman, an educator, also lived there. Except for Willard, the other men bore a general resemblance to Ray, which has raised the charge that Ray’s aliases were given to him as part of a sophisticated conspiracy to kill King. See Chapters 20 and 27 for a further discussion of those aliases.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn08-2",
      "id": "fn08-08-2"
    }
  }, [_vm._v("*")]), _vm._v(" Ray, who evidently considered his actions to show weakness and fear, later emphatically denied ever making such a statement or acting with such dejection. However, both Butler and Thompson were consistent in their recollections, which were first recorded in official statements only two days after the arrest. Thompson’s notes of the encounter record that Ray “was obviously engaged in some mental struggle, and when we left the cell, he again dropped his head in his hands.” Butler testified about the incident, under oath, at Ray’s extradition proceedings only weeks after the arrest. There is little reason to doubt it did not happen as the two British officers described.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fe434e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter08.vue
// module id = 99
// module chunks = 0